"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // import { IconLink, FlexBox } from '../neugelb';

var React = __importStar(require("react"));

var components_1 = require("@lsg/components");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var rich_text_types_1 = require("@contentful/rich-text-types");

var rich_text_react_renderer_1 = require("@contentful/rich-text-react-renderer"); // tslint:disable-next-line:variable-name


exports.ArticleSection = function (_a) {
  var _b;

  var headline = _a.headline,
      subheadline = _a.subheadline,
      referenceLogo = _a.referenceLogo,
      _c = _a.cta,
      ctaText = _c.ctaText,
      ctaHref = _c.ctaHref,
      mainContent = _a.mainContent;

  var _d, _e, _f, _g, _h;

  var options = {
    renderNode: (_b = {}, _b[rich_text_types_1.BLOCKS.EMBEDDED_ASSET] = function (node, children) {
      var url = node.data.target.fields.file.url;
      var width = node.data.target.fields.file.details.image.width;
      return React.createElement("div", {
        style: {
          margin: '48px 0'
        }
      }, React.createElement(components_1.Picture, {
        src: url,
        maxWidth: width
      }, children));
    }, _b[rich_text_types_1.BLOCKS.PARAGRAPH] = function (node, children) {
      return React.createElement(components_1.Paragraph, null, children);
    }, _b)
  };
  return React.createElement(React.Fragment, null, React.createElement(components_1.Section, null, React.createElement("div", {
    style: {
      marginBottom: '48px'
    }
  }, React.createElement(components_1.IconLink, {
    iconName: components_1.Icon.Names.interaction_arrows_chevronLeft,
    onClick: function onClick() {
      return window.history.back();
    }
  }, "Zur\xFCck")), React.createElement(GridRow_1.GridRow, {
    gap: (_d = components_1.Grid.Spacing) === null || _d === void 0 ? void 0 : _d.SECTION,
    verticalAlign: (_e = components_1.Grid.VerticalAlign) === null || _e === void 0 ? void 0 : _e.TOP
  }, React.createElement(GridColumn_1.GridColumn, {
    sm: 8,
    md: 8,
    lg: 8,
    xl: 8
  }, React.createElement(components_1.Headline, null, headline), React.createElement(components_1.Paragraph, null, subheadline), React.createElement(components_1.Button, {
    onClick: function onClick() {
      return window.open(ctaHref, '_blank');
    }
  }, ctaText)), React.createElement(GridColumn_1.GridColumn, {
    textAlign: (_f = components_1.Grid.TextAlign) === null || _f === void 0 ? void 0 : _f.CENTER,
    sm: 4,
    md: 4,
    lg: 4,
    xl: 4
  }, React.createElement(components_1.Picture, {
    src: referenceLogo.url,
    maxWidth: referenceLogo.maxWidth
  })))), React.createElement(components_1.Section, null, React.createElement(GridRow_1.GridRow, {
    gap: (_g = components_1.Grid.Spacing) === null || _g === void 0 ? void 0 : _g.SECTION,
    verticalAlign: (_h = components_1.Grid.VerticalAlign) === null || _h === void 0 ? void 0 : _h.TOP
  }, React.createElement(GridColumn_1.GridColumn, {
    sm: 8,
    md: 8,
    lg: 8,
    xl: 8
  }, rich_text_react_renderer_1.documentToReactComponents(mainContent, options))), React.createElement("div", {
    style: {
      marginTop: '48px'
    }
  }, React.createElement(components_1.IconLink, {
    iconName: components_1.Icon.Names.interaction_arrows_chevronLeft,
    onClick: function onClick() {
      return window.history.back();
    }
  }, "Zur\xFCck"))));
};